(function () {
    'use strict';

    angular.module('app')
        .factory('DivisaSubtipoService', DivisaSubtipoService);

    /* @ngInject */
    function DivisaSubtipoService($resource) {
        return $resource('api/public/divisa/subtipo', {}, {
            'get': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();
